<template>
  <div class="d-flex align-items-center whitespace-nowrap">
    <div class="mr-1">
      <slot name="labelOff">{{ labelOff }}</slot>
    </div>
    <label
      :class="['switch responsive shrink-0', { disabled }]"
      :data-cy="testId"
    >
      <input
        v-model="checked"
        type="checkbox"
        :disabled="disabled"
        autocomplete="off"
      />
      <span class="slider round"></span>
    </label>
    <div class="ml-1">
      <slot name="labelOn">{{ labelOn }}</slot>
    </div>
  </div>
</template>

<script>
import { kebabCase } from "@/lib/helpers.js";
export default {
  name: "ToggleSwitch",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    labelOn: {
      type: String,
      default: ""
    },
    labelOff: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  computed: {
    checked: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    },
    testId() {
      return kebabCase(this.labelOn) || "toggle-switch";
    }
  }
};
</script>

<style lang="scss" scoped></style>
